import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appMaxTwoCharacters]'
})
export class MaxTwoCharactersDirective {
    constructor(private el: ElementRef) {}

    @HostListener('input', ['$event'])
    onInput(event: Event): void {
      const inputElement = this.el.nativeElement as HTMLInputElement;
  
      // Ensure the value does not exceed two characters
      if (inputElement.value.length > 2) {
        inputElement.value = inputElement.value.slice(0, 2);
        // Update the FormControl value
        const eventInput = new Event('input', { bubbles: true });
        inputElement.dispatchEvent(eventInput);
      }
  
    }
}
